import { Link } from '@vkontakte/vkui';
import type { ReactNode } from 'react';

const WEB_URL = /^https?:\/\//i;

/** Адрес, который можно отдать в `href`: только http(s). */
export function isWebUrl(href: string): boolean {
  return WEB_URL.test(href);
}

/**
 * Ссылка наружу посреди строки: профиль ВК в фактах и перечне. Каркас
 * вкуишный (href, фокус, цвет ссылки), кегль берёт у строки. Не http(s) —
 * остаётся текстом: React 18 не режет `javascript:` в href.
 */
export function ExternalLink({ href, children }: { href: string; children: ReactNode }) {
  const web = isWebUrl(href);
  if (!web) return <>{children}</>;

  return (
    <Link href={href} target="_blank" rel="noreferrer">
      {children}
    </Link>
  );
}
